import { QuickUserInfo } from '@app/modules/admin/components/QuickUserInfo';
import { Group, User } from '@mi-front/core';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import PeopleIcon from '@mui/icons-material/People';
import { Chip, Link, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';

export function PermissionUserInfo(p: { user: User }) {
  return <QuickUserInfo user={p.user} />;
}

export function PermissionLinks(p: { user: User }) {
  return (
    <Link
      component={RouterLink}
      to={`/admin/users/${p.user.id}`}
      target="_blank"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        fontSize: '0.875rem',
        textDecoration: 'none',
        '&:hover': {
          textDecoration: 'underline',
        },
      }}
    >
      <OpenInNewIcon fontSize="small" />
      <FormattedMessage id="admin.stations.viewScreen.userLinkText" defaultMessage="Ver usuario" />
    </Link>
  );
}

/** Chip indicating a station permission is inherited from a user group. */
export function PermissionInheritedIndicator(p: { group: Group }) {
  return (
    <Chip
      icon={<PeopleIcon />}
      label={
        <FormattedMessage
          id="admin.stations.viewScreen.permissionInherited"
          defaultMessage="Permiso heredado del grupo {groupName}"
          values={{
            groupName: (
              <Typography component="strong" sx={{ fontWeight: 500 }}>
                {p.group.name}
              </Typography>
            ),
          }}
        />
      }
      variant="outlined"
      size="small"
    />
  );
}

export function AdminIndicator() {
  const { $t } = useIntl();
  return (
    <Chip
      icon={<AdminPanelSettingsIcon />}
      label={$t({
        id: 'admin.permissionsLabel',
        defaultMessage: 'Admin',
      })}
      variant="outlined"
      size="small"
    />
  );
}
